import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverRoundDifferencePouchOperationFilterEntity } from '../../domain/entities/DriverRoundDifferencePouchOperationFilterEntity'

export class DriverRoundDifferencePouchOperationFilterModel extends DriverRoundDifferencePouchOperationFilterEntity {
  fromDate?: string
  toDate?: string
  regionId?: number
  constructor(dataDto: DriverRoundDifferencePouchOperationFilterEntity) {
    super()
    mapEntityProperties<DriverRoundDifferencePouchOperationFilterModel>(this, dataDto, {
      map: {
        fromDate: dataDto.date ? dataDto.date[0] : undefined,
        toDate: dataDto.date ? dataDto.date[1] : undefined,
        regionId: dataDto.region?.id
      }
    })
  }
}
